import viewerSocialProfile from 'models/user/ViewerSocialProfile';
import { useEffect, useState } from 'react';

const AsyncFeatureFlag = {
    isFeatureEnabled: async (key) => {
        let featureRole = await fetch(`/modern/preference/${key}`)
            .then((response) => response.json())
            .then((data) => data);
        return viewerSocialProfile.get('userRoles') && viewerSocialProfile.get('userRoles').includes(featureRole.value);
    },
    isFeatureEnabledForMultipleRoles: async (key) => {
        let featureRoles = await fetch(`/modern/preference/${key}`)
            .then((response) => response.json())
            .then((data) => data.value.split(','));
        // if there are multiple roles allowed for a feature, they should be comma-separated in cloud-config
        return (
            viewerSocialProfile.get('userRoles') &&
            featureRoles.some((role) => viewerSocialProfile.get('userRoles').includes(role.trim()))
        );
    }
};

/**
 * @param {string} roleKey
 */
export const useAsyncFeatureFlag = (roleKey) => {
    const [isEnabled, setIsEnabled] = useState(false);
    useEffect(() => {
        AsyncFeatureFlag.isFeatureEnabled(roleKey).then((value) => setIsEnabled(value));
    }, []);

    return {
        isEnabled
    };
};

export default AsyncFeatureFlag;
